
<app-header></app-header>
<!-- <main role="main" class="flex-shrink-0">
    <div class="container-fluid mt-5 mb-4"> -->
<!-- <div class="container" style="float:left;"> -->
  <ngx-spinner></ngx-spinner>
  <div class="row pb-2 mt-4 ml-1 mr-1">
    <div class="col">
      <h4>
        <div>{{ CreateShowHide ? 'Add' : UpdateShowHide ? 'Edit': ''}} Material Information</div>
      </h4>
    </div>
  </div>
<div class="row mb-2 ml-1 mr-1">
  <div class="col">
    <button type="button" *ngIf="AddShowHide" (click)="AddMaterial()" class="btn btn-success float-right">
      <i class="fas fa-plus-circle"></i> <span>Add Maretial</span>
    </button>
  </div>
</div>
<form [formGroup]="frmMaterial" *ngIf="CreateShowHide || UpdateShowHide">
  <div class="row ml-1 mr-1">
      <div class="col">
          <div class="form-row">
              <div class="form-group col-lg-4">
                <label for="txtMaterial">Material</label><span style="color:red;">&nbsp;*</span>
                <input type="text" class="form-control" id="txtMaterial" formControlName="Material" required>
              </div>
          </div>
      </div>
  </div>

  <div class="row ml-1 mr-1">
      <div class="col">
        <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateMaterial()">
          <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
        </button>
        <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateMaterial()">
          <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
        </button>  
        <a>
          <button type="button" aria-controls="addMaterial" (click)="Cancel()" class="btn btn-secondary">
            <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
          </button>
        </a>
      </div>
  </div>
</form>
<!-- <div id="addMaterial" tabindex="-1" #addMaterial aria-labelledby="addMaterialTitle" *ngIf="CreateShowHide || UpdateShowHide"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role=document>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addMaterialTitle">
            <ng-container *ngIf="CreateShowHide; then addTitle; else editTitle"></ng-container>
              <ng-template #addTitle>
                <div>Enter Material Information</div>
              </ng-template>
              <ng-template #editTitle>
                <div>Edit Material Information</div>
              </ng-template>
          </h5>
        </div>
        <div class="modal-body">
          <form [formGroup]="frmMaterial">
            <div class="form-group row">
              <div class="col-lg-12">
                <label for="txtMaterial">Material</label><span style="color:red;">&nbsp;*</span>
                <input type="text" class="form-control" id="txtMaterial" formControlName="Material" required>
              </div>
            </div>
            <div class="modal-footer">
              <div class="row">
                <div class="col-md-6">
                  <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreateMaterial()">Add</button>
                  <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdateMaterial()">Update</button>
                </div>
                <div class="col-md-6">
                  <button type="button" aria-controls="addMaterial" (click)="Cancel()" class="btn btn-secondary">Cancel</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div> -->
  <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-striped table-bordered table-hover table-sm">
          <thead class="thead-dark">
            <tr>
              <th scope="col" *ngIf="EditShowHide">Actions</th>
              <th scope="col">Material <span (click)="SortOder('Material')"><i class="fas fa-sort"></i></span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items | paginate: config ">
              <td *ngIf="EditShowHide">
                <table>
                  <tr>
                    <td>
                      <button type="button" class="btn btn-info btn-sm"
                              (click)="EditMaterial(item)" title="Edit">
                        <i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                      </button>
                    </td>
                    <td>
                      <button class="btn btn-info btn-sm" (click)="DeleteMaterial(item.Id)" title="Delete">
                        <i class="far fa-trash-alt fa-lg text-danger"></i>
                        <span class="d-none d-md-inline d-lg-inline">Delete</span>
                      </button>
                    </td>
                  </tr>
                </table>               
              </td>
              <td>{{item.Material1}}</td>

            </tr>
            <tr>
              <td colspan="7" style="text-align: right;">
                <pagination-controls (pageChange)="pageChanged($event)" id="Material"></pagination-controls>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
  <!--
  <div class="row" *ngIf="!(CreateShowHide || UpdateShowHide)">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-striped table-bordered table-hover table-sm">
          <thead class="thead-dark">
            <tr>
              <th scope="col" *ngIf="EditShowHide">Actions</th>
              <th scope="col">Material <span (click)="SortOder('Material')"><i class="fas fa-sort"></i></span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items | paginate: config ">
              <td *ngIf="EditShowHide">
                <button type="button" class="btn btn-info btn-sm"
                  (click)="EditMaterial(item)" title="Edit"><i class="fas fa-pen"></i> <span
                    class="d-none d-md-inline d-lg-inline">Edit</span>
                </button>
              </td>
              <td>{{item.Material1}}</td>

            </tr>
            <tr>
              <td colspan="7" style="text-align: right;">
                <pagination-controls (pageChange)="pageChanged($event)" id="Material"></pagination-controls>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>

-->



  <!-- <div class="row mb-2">
    <div class="col">
      <button type="button" *ngIf="AddShowHide" class="btn btn-success float-right" data-toggle="modal"
        data-target="#addMaterial" aria-controls="AddMaterial" (click)="AddMaterial()"><i
          class="fas fa-plus-circle"></i> Add Material</button>

    </div>
  </div>
  <div class="modal fade" id="addMaterial" tabindex="-1" #addMaterial aria-labelledby="addMaterialTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role=document>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addMaterialTitle">Enter Material Information</h5>
          <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="frmMaterial">
            <div class="form-group row">
              <div class="col-lg-12">
                <label for="txtMaterial">Material</label><span style="color:red;">&nbsp;*</span>
                <input type="text" class="form-control" id="txtMaterial" formControlName="Material" required>
              </div>
            </div>
            <div class="modal-footer">
              <div class="row">
                <div class="col-md-6">
                  <button type="button" class="btn btn-success" *ngIf="CreateShowHide"
                    (click)="CreateMaterial()">Add</button>
                  <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" data-toggle="modal"
                    data-dismiss="modal" (click)="UpdateMaterial()">Update</button>
                </div>
                <div class="col-md-6">
                  <button type="button" data-target="#addMaterial" data-toggle="modal" aria-controls="addMaterial"
                    *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary"
                    data-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-striped table-bordered table-hover table-sm">
          <thead class="thead-dark">
            <tr>
              <th scope="col" *ngIf="EditShowHide">Actions</th>
              <th scope="col">Material <span (click)="SortOder('Material')"><i class="fas fa-sort"></i></span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items | paginate: config ">
              <td *ngIf="EditShowHide">
                <button type="button" data-target="#addMaterial" data-toggle="modal" class="btn btn-info btn-sm"
                  (click)="EditMaterial(item)" title="Edit"><i class="fas fa-pen"></i> <span
                    class="d-none d-md-inline d-lg-inline">Edit</span>
                </button>
              </td>
              <td>{{item.Material1}}</td>

            </tr>
            <tr>
              <td colspan="7" style="text-align: right;">
                <pagination-controls (pageChange)="pageChanged($event)" id="Material"></pagination-controls>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div> -->
<!-- </div> -->

<!-- <p>material works!</p>
<div class = "grid-table">
  <div class = "thead">
    <div class = "tr">
      <div class ="td">Material</div>
      <div class ="td">
        <button class = "btn btn-outline-success" (click) = "addMaterialForm()">
          <i class="fa fa-plus"></i> New Material
        </button>
      </div>
      <div class="td">
        <span *ngIf="notification" class="elementToFadeInAndOut">
          <i class="fas fa-check-circle {{notification.class}}"></i>
          {{notification.message}}
        </span>
      </div>
    </div>
  </div>
  <div class ="tbody">
    <form class = "tr" [formGroup] = "fg" *ngFor = "let fg of materialForms.controls ; let i=index;" (submit)="recordSubmit(fg)">
  <div class = "td">
    <input class = "form-control" formControlName = "material1">
  </div>
  <div class="td">
    <button type="submit" class="btn" [disabled]="fg.invalid"
        [ngClass]="(fg.get('id').value==0)?'btn-success':'btn-outline-dark'"><i
            class="far fa-save fa-lg"></i>
        {{fg.get('id').value==0?'Submit':'Update'}}
    </button>
  </div>
  <div class ="td">
    <button class="btn btn-light ml-1" (click)="onDelete(fg.get('id').value,i)">
        <i class="far fa-trash-alt fa-lg text-danger"></i>
        {{'Delete'}}
    </button>
</div>
    </form>
  </div>
</div> -->
